import { render, staticRenderFns } from "./TranslationSettingsModal.vue?vue&type=template&id=85cde882&scoped=true"
import script from "./TranslationSettingsModal.vue?vue&type=script&lang=js"
export * from "./TranslationSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TranslationSettingsModal.vue?vue&type=style&index=0&id=85cde882&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cde882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85cde882')) {
      api.createRecord('85cde882', component.options)
    } else {
      api.reload('85cde882', component.options)
    }
    module.hot.accept("./TranslationSettingsModal.vue?vue&type=template&id=85cde882&scoped=true", function () {
      api.rerender('85cde882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/translation-settings/TranslationSettingsModal.vue"
export default component.exports